import { createSelector, createFeatureSelector } from '@ngrx/store';
import { adapter } from './payment.entity';
import { PaymentState, paymentFeatureKey } from './payment.state';

export const {
    selectAll,
    selectEntities,
    selectIds,
    selectTotal
  } = adapter.getSelectors();

export const getPaymentState = createFeatureSelector<PaymentState>(paymentFeatureKey);

export const getAllPayments = createSelector(getPaymentState, selectAll);

export const getPaymentById = (id: string) => createSelector(getPaymentState, state => state.entities[id]);

export const getError = createSelector(getPaymentState, state => state.error);

export const getTotalCount = createSelector(getPaymentState, state => state.totalCount);

export const getFilter = createSelector(getPaymentState, state => state.filter);

export const getPaymentIntent = createSelector(getPaymentState, state => state.paymentIntent);
export const getGiftCard = createSelector(getPaymentState, state => state.giftCard);

